// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)
